/**
 * Lookup helpers shared by the "form" field components (NiceFormDisplay in tables,
 * EditableFieldForm in the edit modal). Both resolve the referenced state set's id
 * values to labels through the dimension API and must agree on the store key, so a
 * lookup loaded by one is reused by the other.
 */

/** True when the field's stored value is an id resolved to a label via the dimension API. */
export const hasServiceLookup = (field) =>
  Boolean(
    field.serviceType?.trim() &&
    field.serviceImplemenator?.trim() &&
    field.serviceDimension?.trim()
  );

/** The `dimensionKey` the field's lookup values are stored under in the dimensions slice. */
export const formFieldDimensionKey = (field) =>
  `${field.field}-${field.serviceType}-${field.serviceImplemenator}-${field.serviceDimension}`;
